import styles from "./WeddingRegistry.module.scss";
import { Checkbox, Form, Input, Row, Space } from "antd";
import { InputCard } from "../../inventory/component/InputCard";
import { translate } from "../../../core";
import { AddressType } from "../../contact/type/contact";
import { useContext } from "react";
import { PageContextValue } from "../../../core/type";
import { WeddingRegistry, WeddingRegistryEntry } from "../type";
import { WeddingRegistryPageContext } from "./WeddingRegistryPageContext";

const TextArea = Input.TextArea;

type WeddingRegistryFormAddressesProps = {
  isTheSameAddressChanged: (value: boolean) => void;
};

export const WeddingRegistryFormAddresses = ({
  isTheSameAddressChanged,
}: WeddingRegistryFormAddressesProps) => {
  const { form } = useContext<
    PageContextValue<WeddingRegistry, WeddingRegistryEntry>
  >(WeddingRegistryPageContext);

  const getTitle = (index: number): string => {
    const type = getType(index);
    return {
      [AddressType.Billing]: translate("address"),
      [AddressType.Shipping]: translate("ship", "address"),
    }[type];
  };

  const getType = (index: number) => {
    return form?.getFieldValue(["addresses", index, "type"]) as AddressType;
  };

  return (
    <InputCard contained className={styles["customerAddressWrapper"]}>
      <div className={styles.addresses}>
        <Form.List name="addresses">
          {(fields) => (
            <Row>
              {fields.map((field, index) => (
                <InputCard
                  key={`${field.name}-${field.key}`}
                  title={getTitle(index)}
                  className={styles.billingCard + " mb-3"}
                >
                  <Space
                    direction="horizontal"
                    size="middle"
                    align="center"
                    className="justify-content-end"
                    style={{height: '2rem'}}
                  >
                    {getType(index) === AddressType.Shipping && (
                      <>
                        <Form.Item
                          name="theShipmentAddressIsTheSameAsBilling"
                          valuePropName="checked"
                      >
                        <Checkbox
                          onChange={(e) =>
                            isTheSameAddressChanged(e.target.checked)
                          }
                        >
                          {translate("ship_to_same")}
                        </Checkbox>
                      </Form.Item>
                      <Form.Item
                        name="brideGroomEnabled"
                        valuePropName="checked"
                      >
                        <Checkbox>{translate("bride_groom")}</Checkbox>
                      </Form.Item>
                    </>
                  )}
                </Space>
                <div className="d-flex gap-2">
                    <Form.Item
                      label={translate("first_name")}
                      name={[field.name, "firstName"]}
                      className="w-50"
                    >
                      <Input />
                    </Form.Item>

                    <Form.Item
                      label={translate("last_name")}
                      name={[field.name, "lastName"]}
                      className="w-50"
                    >
                      <Input />
                    </Form.Item>
                  </div>

                  <Form.Item
                    label={translate("street")}
                    name={[field.name, "street"]}
                  >
                    <Input />
                  </Form.Item>
                  <div className="d-flex gap-2">
                    <Form.Item
                      label={translate("address", "1")}
                      name={[field.name, "address1"]}
                      className="w-50"
                    >
                      <Input />
                    </Form.Item>

                    <Form.Item
                      label={translate("address", "2")}
                      name={[field.name, "address2"]}
                      className="w-50"
                    >
                      <Input />
                    </Form.Item>
                  </div>

                  <div className="d-flex gap-2">
                    <Form.Item
                      label={translate("city")}
                      name={[field.name, "city"]}
                      className={styles.city}
                    >
                      <Input />
                    </Form.Item>
                    <Form.Item
                      label={translate("state")}
                      name={[field.name, "state"]}
                      className={styles.state}
                    >
                      <Input />
                    </Form.Item>
                    <Form.Item
                      label={translate("zip_code")}
                      name={[field.name, "zipCode"]}
                      className={styles.zipCode}
                    >
                      <Input />
                    </Form.Item>
                    <Form.Item
                      label={translate("country")}
                      name={[field.name, "country"]}
                      className={styles.country}
                    >
                      <Input />
                    </Form.Item>
                  </div>
                </InputCard>
              ))}
            </Row>
          )}
        </Form.List>
        <InputCard title={translate("special_instruction")} className="mb-3">
          <Form.Item name="print" valuePropName="checked" className="mt-1 mb-2">
            <Checkbox>{translate("show")}</Checkbox>
          </Form.Item>
          <Form.Item name="specialInstruction" label=" ">
            <TextArea size="large" rows={4} />
          </Form.Item>
        </InputCard>
      </div>
    </InputCard>
  );
};
